import { render } from "./CompanyPerformance.vue?vue&type=template&id=23fe0b6c"
import script from "./CompanyPerformance.vue?vue&type=script&lang=js"
export * from "./CompanyPerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__